import Field from '@global/FormInput/Field'
import * as S from './JobFilters.styled'

const JobFilters = ({ title, searchFields, onChange, total, queryParams }) => {
  const numberShowing = queryParams.page * queryParams.limit

  return (
    <>
      <S.JobFiltersTitle>{title || 'Current opportunities'}</S.JobFiltersTitle>
      <S.JobFilters>
        <S.JobResultCount>
          {total > 0 && (
            <span>
              1-{total < numberShowing ? total : numberShowing} of&nbsp;
            </span>
          )}
          <span>{total} positions vacant</span>
        </S.JobResultCount>
        <S.JobFilterGroup>
          {searchFields?.map((field) => (
            <Field
              key={field.name}
              {...field}
              label=''
              value={queryParams[field.name] ?? ''}
              placeholder={field.label}
              onChange={(val) => onChange({ [field.name]: val })}
            />
          ))}
        </S.JobFilterGroup>
      </S.JobFilters>
    </>
  )
}

JobFilters.defaultProps = {
  searchFields: [],
}

export default JobFilters
